import ApiClient from '../ApiClient';

const client = new ApiClient({ baseUrl: process.env.NEXT_PUBLIC_API_URL });

export default client;
